import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileRenameForm } from '../forms/FileRenameForm';
import { BpFile } from '../hooks/useFiles';

type FileRenameModalProps = {
  isOpen: boolean;
  file: BpFile;
  onRename: (name: string) => void;
  onClose: () => void;
};

export const FileRenameModal = ({ isOpen, file, onRename, onClose }: FileRenameModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal isOpen={isOpen} loading={loading} onRequestClose={() => onClose()} title={t('common.rename')} width='s'>
      <FileRenameForm
        fileUuid={file.uuid}
        name={file.filename}
        onRename={(name) => onRename(name)}
        onLoad={(loading) => setLoading(loading)}
        onClose={() => onClose()}
      />
    </Modal>
  );
};
